import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { filter, map, take, tap } from 'rxjs';

export const canVisitGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    filter((isAuthenticated): isAuthenticated is boolean => isAuthenticated !== undefined),
    take(1), 
    map((isAuthenticated: boolean) => {
      if (isAuthenticated) {
        const landingPageUrl = auth.getLandingPageUrl();
        return router.createUrlTree([landingPageUrl]); // redirect
      }
      
      return true; // allow access if not authenticated
    })
  );
};
